import { Component, OnInit, ViewChild, AfterViewChecked, ElementRef, OnDestroy } from '@angular/core';
import { Response } from '@angular/http';
import { AlertService } from 'ng-jhipster';

import { SaisineStatus } from './saisine.model';
import { Saisineline } from './saisineline.model';

import { SaisineLineService } from './saisineline.service';
import { Principal } from '../../shared';
import { isNullOrUndefined } from 'util';
import { CampaignService } from '../campaign/campaign.service';
import { Subscription } from 'rxjs/Subscription';
import { EMPTY_OPTION, MultiSelectOption, UtilsService, SAISINE_STATUS } from '../../shared/utils/utils.service';
import { LazyLoadEvent } from 'primeng/primeng';
import { RegionService } from '../../admin/user-management/region.service';

@Component({
    selector: 'jhi-saisine',
    templateUrl: './saisine.component.html'
})
export class SaisineComponent implements OnInit, AfterViewChecked, OnDestroy {

    saisines: Saisineline[];
    possibleStatus: MultiSelectOption[];
    selectStatus: number[];
    possibleLicenceAcademies: MultiSelectOption[];
    selectLicenceAcademy: string;
    possibleRegions: MultiSelectOption[];
    selectLicenceRegion: string;
    possibleDisability: any[];
    selectDisability: any;
    multiSortMeta: any[];
    @ViewChild('dtSaisineComponent') dtSaisineComponent;
    initialized: boolean;

    totalEveryRecords: number;
    totalRecords: number;

    lazyLoadEvent: LazyLoadEvent;
    timeout: number;
    loading: boolean;

    private subscription: Subscription = new Subscription();
    private listSubscription: Subscription = new Subscription();

    constructor(
        private saisineService: SaisineLineService,
        private alertService: AlertService,
        private principal: Principal,
        private elementRef: ElementRef,
        private campaignService: CampaignService,
        public regionService: RegionService,
        public utilsService: UtilsService
    ) {
        this.initialized = false;
    }


    loadLazy(event: LazyLoadEvent, force = false) {
        if (event.filters) {
            Object.keys(event.filters).filter(k => (event.filters[k] && (event.filters[k].value === '' || (Array.isArray(event.filters[k].value) && event.filters[k].value.length === 0)))).forEach(k => delete event.filters[k]);
        }
        if (!force && JSON.stringify(this.lazyLoadEvent) === JSON.stringify(event)) {
            return;
        }
        let time = (!this.lazyLoadEvent) ? 1000 : (JSON.stringify(this.lazyLoadEvent.filters) === JSON.stringify(event.filters)) ? 100 : 1000;
        this.lazyLoadEvent = JSON.parse(JSON.stringify(event));
        if (this.listSubscription) {
            this.listSubscription.unsubscribe();
        }
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = window.setTimeout(() => {
            this.loading = true;
            this.listSubscription = this.saisineService.query({ 'campaign': this.campaignService.getDisplayedCampaign(), ...event }).subscribe(
                (res: Response) => {
                    this.totalRecords = +res.headers.get('X-total-count');
                    this.saisines = res.json();
                    this.storeDtState();
                },
                (res: Response) => this.onError(res),
                () => this.loading = false
            );
        }, time);
    }
    loadTotals() {
        setTimeout(() => {
            this.saisineService.count({ 'campaign': this.campaignService.getDisplayedCampaign() }).subscribe((res: Response) => this.totalEveryRecords = +res.headers.get('X-total-count'));
        }, 500);
    }

    ngOnInit() {
        this.possibleStatus = SAISINE_STATUS;
        this.possibleDisability = [EMPTY_OPTION, { label: 'Oui', value: true }];
        this.regionService.getRegions({ 'campaign': this.campaignService.getDisplayedCampaign() }).subscribe(() => {
            this.possibleRegions = this.regionService.getRegionOptions();
        });

        this.loadTotals();

        this.subscription.add(this.campaignService.notifyObservable$.subscribe((res) => {
            if (res === 'saisines') {
                this.possibleRegions = this.regionService.getRegionOptions();
                this.cleanSelectedFilterValues();
                this.loadTotals();
                this.loadLazy(this.lazyLoadEvent, true);
                this.setPage(0);
            }
        }));
    }

    storeDtState() {
        if (!isNullOrUndefined(this.dtSaisineComponent) && !isNullOrUndefined(this.dtSaisineComponent.multiSortMeta)) {
            localStorage.setItem('SaisineComponentSort', JSON.stringify(this.dtSaisineComponent.multiSortMeta));
        }
        if (!isNullOrUndefined(this.dtSaisineComponent) && !isNullOrUndefined(this.dtSaisineComponent.filters)) {
            localStorage.setItem('SaisineComponentFilters', JSON.stringify(this.dtSaisineComponent.filters));
        }
        if (!isNullOrUndefined(this.dtSaisineComponent) && !isNullOrUndefined(this.dtSaisineComponent.rows)) {
            localStorage.setItem('SaisineComponentRows', JSON.stringify(this.dtSaisineComponent.rows));
        }
        if (!isNullOrUndefined(this.dtSaisineComponent) && !isNullOrUndefined(this.dtSaisineComponent.first)) {
            sessionStorage.setItem('SaisineComponentPage', JSON.stringify(this.dtSaisineComponent.first));
        }
    }

    ngAfterViewChecked() {
        if (this.dtSaisineComponent && !this.initialized) {
            // wait a tick to avoid one-time devMode
            // unidirectional-data-flow-violation error
            setTimeout(_ => this.onLoad());
            this.initialized = true;
        }
        this.changeBgColorStatusNew();
        this.changeBgColorHasProposals();
        this.changeBgColorHandicap();
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    // restaure soit un filtre sauvegardé soit un filtre associe au profil
    onLoad() {
        let sortLocalStorage = JSON.parse(localStorage.getItem('SaisineComponentSort'));
        let filtersLocalStorage = JSON.parse(localStorage.getItem('SaisineComponentFilters'));
        let rowsLocalStorage = Number(localStorage.getItem('SaisineComponentRows'));
        let pageSessionStorage = Number(sessionStorage.getItem('SaisineComponentPage'));
        if (sortLocalStorage) {
            this.multiSortMeta = sortLocalStorage;
        } else {
            this.loadDefaultSort();
        }
        if (filtersLocalStorage) {
            this.dtSaisineComponent.filters = filtersLocalStorage;
        } else {
            this.loadDefaultFilters();
        }
        this.applyTableState(pageSessionStorage, rowsLocalStorage ? rowsLocalStorage : 10);
    }

    cleanSelectedFilterValues() {
        setTimeout(() => {
            let filters = this.dtSaisineComponent.filters;
            // le list of status is different depending on profiles, the non present items should be removed
            if (filters.status) {
                filters.status.value = filters.status.value.filter(v => this.possibleStatus.find(ps => ps.value === v));
            }
            if (filters.licenceAcademicRegionLabel) {
                filters.licenceAcademicRegionLabel.value = this.possibleRegions.find(_ => _.value === filters.licenceAcademicRegionLabel.value) ? filters.licenceAcademicRegionLabel.value : '';
            }
            this.possibleLicenceAcademies = this.regionService.getAcademyOptions(filters.licenceAcademicRegionLabel ? filters.licenceAcademicRegionLabel.value : '');
            if (filters.licenceAcademyLabel) {
                filters.licenceAcademyLabel.value = this.possibleLicenceAcademies.find(_ => _.value === filters.licenceAcademyLabel.value) ? filters.licenceAcademyLabel.value : '';
            }
        }, 0);
    }

    loadDefaultFilters() {
        this.dtSaisineComponent.reset();
        this.dtSaisineComponent.filters['id'] = { matchMode: 'contains', value: '' };
        this.dtSaisineComponent.filters['licenceTitle'] = { matchMode: 'contains', value: '' };
        this.dtSaisineComponent.filters['licenceSchoolLabel'] = { matchMode: 'contains', value: '' };
        this.dtSaisineComponent.filters['licenceAcademyLabel'] = { matchMode: 'equals', value: '' };
        this.dtSaisineComponent.filters['licenceAcademicRegionLabel'] = { matchMode: 'equals', value: '' };
        this.dtSaisineComponent.filters['hasDisability'] = { matchMode: 'equals', value: '' };
        this.dtSaisineComponent.filters['status'] = { matchMode: 'in', value: [] };
        if (this.principal.hasSyncAuthority('ROLE_ACADEMICRECTOR')) {
            this.dtSaisineComponent.filters['status'].value = [SaisineStatus.CHECKED];
            this.dtSaisineComponent.filters['licenceAcademyLabel'].value = this.principal.getAcademyCode();
        } else if (this.principal.hasSyncAuthority('ROLE_ACADEMICREGIONRECTOR')) {
            this.dtSaisineComponent.filters['status'].value = [SaisineStatus.TO_CHECK, SaisineStatus.CHECKED];
            this.dtSaisineComponent.filters['licenceAcademicRegionLabel'].value = this.principal.getAcademicRegionLabel();
        }
    }

    loadDefaultSort(): void {
        this.multiSortMeta = [];
        this.multiSortMeta.push({ field: 'lastModificationDate', order: -1 });
    }

    reapplyDefaultTableState(): void {
        if (this.initialized) {
            this.loadDefaultSort();
            this.loadDefaultFilters();
            this.applyTableState(0, 20);
        }
    }

    applyTableState(page, nbRows) {
        this.selectStatus = (this.dtSaisineComponent && this.dtSaisineComponent.filters['status']) ? this.dtSaisineComponent.filters['status'].value : [];
        this.selectDisability = (this.dtSaisineComponent && this.dtSaisineComponent.filters['hasDisability']) ? this.dtSaisineComponent.filters['hasDisability'].value : '';
        this.selectLicenceAcademy = (this.dtSaisineComponent && this.dtSaisineComponent.filters['licenceAcademyLabel']) ? this.dtSaisineComponent.filters['licenceAcademyLabel'].value : '';
        this.selectLicenceRegion = (this.dtSaisineComponent && this.dtSaisineComponent.filters['licenceAcademicRegionLabel']) ? this.dtSaisineComponent.filters['licenceAcademicRegionLabel'].value : '';
        this.dtSaisineComponent.multiSortMeta = this.multiSortMeta;
        if (this.dtSaisineComponent.multiSortMeta && Array.isArray(this.dtSaisineComponent.multiSortMeta) && this.dtSaisineComponent.multiSortMeta.length) {
            this.dtSaisineComponent.sortMultiple();
        } else {
            this.dtSaisineComponent._filter();
        }
        this.dtSaisineComponent.rows = nbRows;
        this.cleanSelectedFilterValues();
        setTimeout(_ => this.setPage(page ? page : 0));
    }

    setPage(page) {
        let paging = {
            first: page,
            rows: this.dtSaisineComponent.rows
        };
        this.dtSaisineComponent.paginate(paging);
    }

    stopPropagation(event) {
        event.stopImmediatePropagation();
        document.getElementsByTagName('body')[0].click();
    }

    changeBgColorStatusNew(): void {
        let elems = this.elementRef.nativeElement.querySelectorAll('.new-to-check');
        for (let i = 0; i < elems.length; i++) {
            if (!isNullOrUndefined(elems[i])) {
                let parentElem = elems[i].parentElement;
                if (!isNullOrUndefined(parentElem)) {
                    let column = parentElem.parentElement;
                    if (!isNullOrUndefined(column)) {
                        column.style.backgroundColor = '#5bc0de';
                    }
                }
            }
        }
    }
    changeBgColorHasProposals(): void {
        let elems = this.elementRef.nativeElement.querySelectorAll('.with-proposals');
        for (let i = 0; i < elems.length; i++) {
            if (!isNullOrUndefined(elems[i])) {
                let parentElem = elems[i].parentElement;
                if (!isNullOrUndefined(parentElem)) {
                    let column = parentElem.parentElement;
                    if (!isNullOrUndefined(column)) {
                        column.style.backgroundColor = '#ffefb1';
                    }
                }
            }
        }
    }
    changeBgColorHandicap(): void {
        let elems = this.elementRef.nativeElement.querySelectorAll('.fa-wheelchair');
        for (let i = 0; i < elems.length; i++) {
            if (!isNullOrUndefined(elems[i])) {
                let parentElem = elems[i].parentElement;
                if (!isNullOrUndefined(parentElem)) {
                    let column = parentElem.parentElement;
                    if (!isNullOrUndefined(column)) {
                        column.style.backgroundColor = '#5cb85c';
                        column.style.color = '#ffffff';
                    }
                }
            }
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.listSubscription.unsubscribe();
    }

    export() {
        let event = JSON.parse(JSON.stringify(this.lazyLoadEvent));
        event.first = 0;
        event.rows = 2147483647;
        this.listSubscription = this.saisineService.query({ 'campaign': this.campaignService.getDisplayedCampaign(), ...event }).subscribe(
            (res: Response) => {
                this.totalRecords = +res.headers.get('X-total-count');
                this.saisines = res.json();
                setTimeout(_ => this.utilsService.datatableExportCSV(this.dtSaisineComponent, this.possibleStatus));
            },
            (res: Response) => this.onError(res)
        );
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine.component.ts